module.exports = __webpack_public_path__ + "img/machine-10.b36bc6a7.svg";